import {
  defaultTokenService,
  refreshAccessToken,
} from '@euler/services/factory';
import { CaptureMessage, SpeechStart } from './capturePage';
import { SpeechEndpoint } from './speechEndpoint';

/** How the host drives the capture page. */
export interface SpeechCaptureHandle {
  /** Starts a hold; its start frame carries `payload` (the endpoint's own). */
  start: (payload: SpeechStart) => void;
  stop: () => void;
  cancel: () => void;
}

export interface SpeechCaptureProps {
  /** Where the voice goes. Its fields, not its identity, reload the page. */
  endpoint: SpeechEndpoint;
  /** Every message but `authorize`, which the host answers itself. */
  onMessage: (message: CaptureMessage) => void;
}

/** Refreshed this long before it expires, as the chat socket does. */
const kRefreshWindowMs = 60_000;

/** A token for the speech socket: refreshed when asked or nearly expired. */
export async function captureToken(refresh: boolean): Promise<string | null> {
  try {
    if (refresh) return await refreshAccessToken();
    const token = await defaultTokenService.getToken();
    const exp = await defaultTokenService.getTokenExpiry();
    if (token && exp != null && exp * 1000 - Date.now() < kRefreshWindowMs)
      return await refreshAccessToken();
    return token;
  } catch (error) {
    console.error('speech capture token failed', error);
    return null;
  }
}
